module.exports = __webpack_public_path__ + "static/media/IMG_1470.3cf9cfb1.jpg";